import React, { useEffect } from "react";
import { Authenticator, useTheme } from "@aws-amplify/ui-react"; 
// import ModernAuthenticator from "../../components/";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";

import CardSection from "../../components/ui/CardSection";
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import BeautyButton from '../../components/BeautyButton';

const CustomAuthHeader = () => {
  const { tokens } = useTheme();
  return (
    <div style={{ padding: `${tokens.space.xl} 0` }}>
      <h1 style={{ textAlign: "center" }}>Sign in or create an account</h1>
    </div>
  );
};

const CustomAuthFooter = () => {
  const { tokens } = useTheme();
  return (
    <div style={{ padding: `${tokens.space.xl} 0` }}>
      <p style={{ textAlign: "center" }}>CosmelytiX &copy; 2025</p>
    </div>
  );
};

const UserAccountPage = () => {

  async function safeFetchSession() {
    try {
      const session = await fetchAuthSession({forceRefresh: true});
      const {idToken, accessToken, refreshToken, username} = await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens()
      return session;
    } catch (err) {
      if (
        err.name === "InvalidIdentityPoolConfigurationException" ||
        err.name === "NotAuthorizedException"
      ) {
        // Clear broken identity
        // Cache.clear(); // Amplify-specific
        // localStorage.clear();
        // sessionStorage.clear();
        // Amplify.configure(awsExports);
        // const { username, userId, userIdentityId } = await Auth.currentAuthenticatedUser();
        //   console.log("username>>", username);
        //   console.log("user id>>", userIdentityId);
        // // Retry
        // const session = await fetchAuthSession();
        // console.log("session", session);
        // return session;
      } else {
        throw err;
      }
    }
  }

  useEffect(() => {
    const fetchSessionIfAuthenticated = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          safeFetchSession();
        }
      } catch (error) {
        // not signed in
      }
    };

    fetchSessionIfAuthenticated();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-surface" style={{ backgroundColor: "#7A6E62" }}>
      <Header />
      <Authenticator components={{ Header: CustomAuthHeader, Footer: CustomAuthFooter }}>
        {({ signOut, user }) => {
          return (
            <main className={`flex-grow py-6 ${user ? "" : "bg-auth-background"}`}>
              <div className="mx-auto px-2 sm:px-6 ">
                {user ? (
                  <>
                    <div className="space-y-6">


                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        {/* Recommendations */}
                        <CardSection
                          title={<BeautyButton text="recommendations" type="account" showCloseButton={false} >
                           <img
      src="/assets/images/screens/recs.jpg" 
    />
                           <div className="rounded overflow-hidden" >
                               
    <a href="/recommendations">
    <button className="all-[unset] box-border relative w-full h-[74px] cursor-pointer group">
  <div className="relative w-full h-[74px] rounded-[50px] border-2 border-solid border-white group-hover:border-secondary transition-colors duration-200 flex items-center justify-center">
    <span className="text-white group-hover:text-secondary transition-colors duration-200  font-normal text-[28px] tracking-[0] leading-[normal]">
      View products
    </span>
  </div>
</button>
</a>
  </div>
                          </BeautyButton>
                          }
                          desc="Explore personalized product recommendations powered by AI and smart technology, tailored to your skin’s unique needs."
                          imageUrl="/assets/images/account/Explore-personalized-product-recommendations.jpg"
                          imagePosition="left"
                        />


                        {/* Products */}
                        <CardSection
                          title={<BeautyButton text="products" type="account" showCloseButton={false} >
                          <div className="rounded overflow-hidden">
   <img
     src="public/assets/images/screens/table.jpg"
     alt="products"
     className="rounded-lg w-full h-auto mb-4"
   />
   <a href="/products">
   <button className="all-[unset] box-border relative w-full h-[74px] cursor-pointer group">
 <div className="relative w-full h-[74px] rounded-[50px] border-2 border-solid border-white group-hover:border-secondary transition-colors duration-200 flex items-center justify-center">
   <span className="text-white group-hover:text-secondary transition-colors duration-200  font-normal text-[28px] tracking-[0] leading-[normal]">
     View products
   </span>
 </div>
</button>
</a>
 </div>
                         </BeautyButton>}
                          desc="Explore our curated cosmetics database and add products to your skin profile to receive personalized tailored recommendations."
                          imageUrl="/assets/images/account/View-and-manage-your-saved-products.jpg"
                          imagePosition="left"
                        />
                        {/* Saved Ingredients */}
                        <CardSection
                          title={<BeautyButton text="ingredients" type="account"  showCloseButton={false} >
                          <div className="rounded overflow-hidden">
   {/* <img
     src="/assets/images/screens/recs.jpg"
     alt="Special offer"
     className="rounded-lg w-full h-auto mb-4"
   /> */}
   <a href="/skin-passport">
   <button className="all-[unset] box-border relative w-full h-[74px] cursor-pointer group">
 <div className="relative w-full h-[74px] rounded-[50px] border-2 border-solid border-white group-hover:border-secondary transition-colors duration-200 flex items-center justify-center">
   <span className="text-white group-hover:text-secondary transition-colors duration-200  font-normal text-[28px] tracking-[0] leading-[normal]">
     View ingredients
   </span>
 </div>
</button>
</a>
 </div>
                         </BeautyButton>}
                          desc="Keep track of your ingredients."
                          imageUrl="/assets/images/account/Keep-track-of-your-saved-chemical-ingredients.jpg"
                          imagePosition="right"
                        />
                        {/* Track Ingredients */}
                        <CardSection
                          title={<BeautyButton text="science" type="account"  showCloseButton={false} >
                          <div className="rounded overflow-hidden">
   {/* <img
     src="/assets/images/screens/recs.jpg"
     alt="Special offer"
     className="rounded-lg w-full h-auto mb-4"
   /> */}
   <a href="/science">
   <button className="all-[unset] box-border relative w-full h-[74px] cursor-pointer group">
 <div className="relative w-full h-[74px] rounded-[50px] border-2 border-solid border-white group-hover:border-secondary transition-colors duration-200 flex items-center justify-center">
   <span className="text-white group-hover:text-secondary transition-colors duration-200  font-normal text-[28px] tracking-[0] leading-[normal]">
     View discoveries
   </span>
 </div>
</button>
</a>
 </div>
                         </BeautyButton>}
                          desc="Explore the latest anti-aging and skincare innovations—used by Cosmelytix to refine our personalized recommendations."
                          imageUrl="/assets/images/account/Monitor-the-mix-of-ingredients-you-use.jpg"
                          imagePosition="right"
                        />
                        <CardSection
                          title= {<BeautyButton text="subscription" type="account"   showCloseButton={false} >
                          <div className="rounded overflow-hidden">
   {/* <img
     src="/assets/images/screens/recs.jpg"
     alt="Special offer"
     className="rounded-lg w-full h-auto mb-4"
   /> */}
   <a href="/prices">
   <button className="all-[unset] box-border relative w-full h-[74px] cursor-pointer group">
 <div className="relative w-full h-[74px] rounded-[50px] border-2 border-solid border-white group-hover:border-secondary transition-colors duration-200 flex items-center justify-center">
   <span className="text-white group-hover:text-secondary transition-colors duration-200  font-normal text-[28px] tracking-[0] leading-[normal]">
     View subscriptions
   </span>
 </div>
</button>
</a>
 </div>
                         </BeautyButton>}
                          desc="You are on a 'FREE' plan."
                          href="/new-additions"
                          imageUrl="/assets/images/account/online-subscription.jpg"
                          imagePosition="left"
                          />
                        {/* Sign Out */}
                        <CardSection
                          title={<BeautyButton text="sign out" type="account"  showCloseButton={false} >
                          <div className="rounded overflow-hidden">
   {/* <img
     src="/assets/images/screens/recs.jpg"
     alt="Special offer"
     className="rounded-lg w-full h-auto mb-4"
   /> */}
   {/* <a href="/recommendations"> */}
   <button onClick={signOut} className="all-[unset] box-border relative w-full h-[74px] cursor-pointer group">
 <div className="relative w-full h-[74px] rounded-[50px] border-2 border-solid border-white group-hover:border-secondary transition-colors duration-200 flex items-center justify-center">
   <span className="text-white group-hover:text-secondary transition-colors duration-200  font-normal text-[28px] tracking-[0] leading-[normal]">
     Sign out
   </span>
 </div>
</button>
{/* </a> */}
 </div>
                         </BeautyButton>}
                          desc="Securely sign out of your account."
                          imageUrl="/assets/images/account/sign-out-from-website.jpg"
                          imagePosition="left"
                          style={{ 'width': 'auto;', 'border-color':'white;' }}
                        >
 {/* <button onClick={signOut} className="px-6 py-3 bg-red-500 text-white font-semibold rounded-md hover:bg-red-600 transition-colors w-full">Sign Out</button> */}
 </CardSection>
                      </div>
                    </div>
                  </>
                ) : (
                  <h1 className="text-3xl font-display font-bold text-text-primary mb-8">
                    Please sign in to access your account.
                  </h1>
                )}
              </div>
            </main>
          );
        }}
      </Authenticator>
      <Footer />
    </div>
  );
};


export default UserAccountPage;
